import * as t from 'io-ts';

import {PanelTypesEnum, RLegacyPanelId, RPanelStateBase} from '../panelStateBase';

/*
 * Runtime types.
 */

export const RLegacyPanelStateDirty = t.intersection([
  RPanelStateBase,
  t.type({
    id: RLegacyPanelId,
    type: t.literal(PanelTypesEnum.LEGACY),
    path: t.string,
  }),
]);

/*
 * Types.
 */

export interface LegacyPanelState extends Readonly<t.TypeOf<typeof RLegacyPanelStateDirty>> {}
export const RLegacyPanelState = t.clean<LegacyPanelState>(RLegacyPanelStateDirty as any);
